import React from "react";

import { Breadcrumbs } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useHistory } from "react-router-dom";

import useStyles from "./styles";

export type Item = {
  title?: string;
  color?: string;
  dataCy?: string;
  link?: {
    url: string;
    state?: unknown;
  };
};

type Props = {
  items?: Item[];
};

const Breadcrumb = (props: Props) => {
  const classes = useStyles();

  const { items } = props;

  const history = useHistory();

  const onClickItem = (item: Item) => {
    if (item?.link && item?.link?.url) history.push(item?.link?.url, item?.link?.state);
  };

  const renderItems = () => {
    if (items && items.length > 0) {
      return items.map((item, index) => {
        if (item?.title) {
          return (
            <div
              key={index}
              onClick={() => onClickItem(item)}
              className={item?.link && item?.link?.url ? classes.link : undefined}
            >
              <span data-cy={item?.dataCy} style={{ color: item?.color }} className={classes.title}>
                {item?.title}
              </span>
            </div>
          );
        }

        return null;
      });
    }

    return null;
  };

  return (
    <Breadcrumbs
      separator={<ChevronRightIcon className={classes.icon} htmlColor="#6F727A" />}
      aria-label="breadcrumb"
    >
      {renderItems()}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
